import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { requestAllUsers, setUserById } from "../../../../store/slices/users";
import { ProfileUserSideBar } from "../../../../components/ProfileUserSideBar";
import { UserProfileProjects } from "../../../../components/UserProfileProjects";
import { ProfileUserHeader } from "../../../../components/ProfileUserHeader";

import { ProfilePageWrapper } from "../../../Profile/styles";

export const UserById = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      requestAllUsers({
        limit: 100,
        callbacks: {
          onSuccess: (data) => {
            dispatch(
              setUserById(data?.items?.find((user) => user?.uid === id))
            );
          },
        },
      })
    );
  }, [dispatch, id]);

  return (
    <>
      <ProfileUserHeader />

      <ProfilePageWrapper>
        <ProfileUserSideBar />
        <UserProfileProjects />
      </ProfilePageWrapper>
    </>
  );
};
